import { useCallback, useMemo } from "react";

import { useTrackingScope } from "@/hooks/use-tracking-scope";
import {
  buildScopedClientAnalyticsEvent,
  type ScopedClientAnalyticsEvent,
} from "@/lib/site-tracking/buildScopedClientAnalyticsEvent";
import { trackClientEvent } from "@/lib/site-tracking/trackClientEvent";

/** Sends browser events with the accumulated page and section scope. */
export function useAnalytics() {
  const inheritedScope = useTrackingScope();
  const scope = useMemo(
    () => ({
      entityType: inheritedScope.entityType,
      surface: inheritedScope.surface,
    }),
    [inheritedScope.entityType, inheritedScope.surface],
  );
  const track = useCallback(
    (event: ScopedClientAnalyticsEvent) => {
      const scopedEvent = buildScopedClientAnalyticsEvent(scope, event);
      if (scopedEvent) trackClientEvent(scopedEvent);
    },
    [scope],
  );

  return { scope, track } as const;
}
